import { ComponentPropsWithoutRef, FC, ReactNode, Ref } from 'react';
import classNames from 'classnames';

import styles from './BottomSheetFooter.module.css';

export type BottomSheetFooterDirection = 'column' | 'column-reverse' | 'row' | 'row-reverse';

export type BottomSheetFooterProps = {
  children?: ReactNode;
  className?: string;
  /** Порядок кнопок. По умолчанию `'column-reverse'` — стопка, последний ребёнок сверху. */
  direction?: BottomSheetFooterDirection;
  ref?: Ref<HTMLDivElement>;
} & Omit<ComponentPropsWithoutRef<'div'>, 'className'>;

const DIRECTION_CLASS_NAME: Record<BottomSheetFooterDirection, string | undefined> = {
  'column-reverse': undefined,
  column: styles.directionColumn,
  row: styles.directionRow,
  'row-reverse': styles.directionRowReverse,
};

/** Футер шторки, закреплён под Body. Без Footer кнопки скроллятся вместе с контентом. */
const BottomSheetFooter: FC<BottomSheetFooterProps> = ({
  children,
  className,
  direction = 'column-reverse',
  ref,
  ...rest
}) => (
  <div
    ref={ref}
    {...rest}
    className={classNames(styles.footer, DIRECTION_CLASS_NAME[direction], className)}>
    {children}
  </div>
);

export default BottomSheetFooter;
